import Request, { SimpleResponse } from './Request';

export interface IWeekPeriod {
    startDateW1: number;
    endDateW1: number;
}

class WeekPeriod {
    static GetActual = (): IWeekPeriod => { return Request.DoGet('weekperiod/actual') as unknown as IWeekPeriod; };
    static UpdateActual = (data: IWeekPeriod): SimpleResponse => { return Request.DoPut('weekperiod/actual', data) as unknown as SimpleResponse; };
    static GetPlan = (): IWeekPeriod => { return Request.DoGet('weekperiod/plan') as unknown as IWeekPeriod; };
    static UpdatePlan = (data: IWeekPeriod): SimpleResponse => { return Request.DoPut('weekperiod/plan', data) as unknown as SimpleResponse; };
}

export default WeekPeriod;